import { useEffect, useState } from "react";
const API = "/api";
const token = () => localStorage.getItem("token");

export default function Resenas() {
  const [resenas, setResenas] = useState<any[]>([]);

  const cargar = () => {
    fetch(`${API}/resenas/admin`,{headers:{Authorization:`Bearer ${token()}`}})
      .then(r=>r.json()).then(d=>Array.isArray(d)&&setResenas(d)).catch(()=>{});
  };
  useEffect(()=>{cargar();},[]);

  const aprobar = async (id:number) => {
    await fetch(`${API}/resenas/${id}/aprobar`,{method:"PUT",headers:{Authorization:`Bearer ${token()}`}});
    cargar();
  };
  const eliminar = async (id:number) => {
    await fetch(`${API}/resenas/${id}`,{method:"DELETE",headers:{Authorization:`Bearer ${token()}`}});
    cargar();
  };

  return (
    <div>
      <h1 style={{fontFamily:"Montserrat,sans-serif",fontSize:"24px",fontWeight:900,marginBottom:"24px",color:"#1a1a2e"}}>Resenas ({resenas.length})</h1>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:"16px"}}>
        {resenas.map(r => (
          <div key={r.id} style={{background:"#fff",borderRadius:"16px",padding:"20px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)",borderTop:`3px solid ${r.aprobada?"#22c55e":"#f59e0b"}`}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"8px"}}>
              <div style={{fontWeight:800}}>{r.nombre}</div>
              <span style={{fontSize:"11px",padding:"3px 8px",borderRadius:"20px",fontWeight:700,background:r.aprobada?"#dcfce7":"#fef3c7",color:r.aprobada?"#16a34a":"#d97706"}}>
                {r.aprobada?"Aprobada":"Pendiente"}
              </span>
            </div>
            <div style={{color:"#f59e0b",marginBottom:"8px"}}>{"⭐".repeat(r.estrellas)}</div>
            <p style={{fontSize:"13px",color:"#6b7280",marginBottom:"16px",lineHeight:1.6}}>{r.texto}</p>
            <div style={{display:"flex",gap:"8px"}}>
              <button onClick={()=>aprobar(r.id)}
                style={{flex:1,background:r.aprobada?"#fef3c7":"#dcfce7",color:r.aprobada?"#d97706":"#16a34a",border:"none",padding:"8px",borderRadius:"8px",fontWeight:700,fontSize:"12px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>
                {r.aprobada?"Desaprobar":"Aprobar"}
              </button>
              <button onClick={()=>eliminar(r.id)}
                style={{background:"#fef2f2",color:"#ef4444",border:"none",padding:"8px 12px",borderRadius:"8px",fontWeight:700,fontSize:"12px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>
                🗑️
              </button>
            </div>
          </div>
        ))}
        {resenas.length===0&&<div style={{textAlign:"center",padding:"60px",color:"#9ca3af",background:"#fff",borderRadius:"16px",gridColumn:"1/-1"}}>No hay resenas aun</div>}
      </div>
    </div>
  );
}
